import { useState } from "react";
import type { ReportField, TabularGeneralSettings } from "../../../../../../../api/types/svTypes.ts";
import { getTabularExportWarning } from "../../common/export/exportWarnings.ts";
import ExcelReportExport from "../../common/export/ExcelReportExport.tsx";
import type { ExcelExportSource } from "../../common/export/exportTypes.ts";
import type { TabularGridState } from "../../viewer/tabular/hooks/gridState.types.ts";
import type { CashFlowMode } from "./cashFlowRows.ts";
import CashFlowPreview from "./CashFlowPreview.tsx";
import { getCashFlowSettings } from "./getCashFlowSettings.ts";

const getCashFlowExportSource = <T extends ExcelExportSource>(source: T, settings: TabularGeneralSettings): T => ({
  ...source,
  requestConfig: { ...source.requestConfig, settings },
});

interface Props {
  gridState: TabularGridState;
  fields: ReportField[];
  settings: TabularGeneralSettings;
  exportSource?: ExcelExportSource;
}

const CashFlowReportPreview = ({ gridState, fields, settings, exportSource }: Props) => {
  const [displayMode, setDisplayMode] = useState<CashFlowMode>();
  const cashFlowSettings = getCashFlowSettings(settings);
  const mode = displayMode ?? cashFlowSettings.displayMode;
  return (
    <>
      {exportSource && (
        <ExcelReportExport
          {...getCashFlowExportSource(exportSource, {
            ...settings,
            cashFlow: { ...cashFlowSettings, displayMode: mode },
          })}
          warning={getTabularExportWarning(gridState)}
        />
      )}
      <CashFlowPreview
        gridState={gridState}
        fields={fields}
        settings={cashFlowSettings}
        displayMode={mode}
        onDisplayModeChange={setDisplayMode}
      />
    </>
  );
};

export default CashFlowReportPreview;
